import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { WeightItemService } from "../../../../../services/weightitem.service";

@Component({
  selector: "tickets",
  templateUrl: "./tickets.component.html",
  styleUrls: ["./tickets.component.css"],
})
export class TicketsComponent implements OnInit {
  @Input() table_id: string;
  @Input() data;
  @Input() order;
  @Input() orderby;
  @Output() out: EventEmitter<any>;
  @Output() sortby: EventEmitter<any>;

  public identity;

  public selectrow = null;

  public data2;
  public token;

  constructor(private weightService: WeightItemService) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.out = new EventEmitter();
    this.sortby = new EventEmitter();
    this.token = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit() {
    // console.log(this.table_id);
    this.data2 = this.data.map((element) => {
      //  // Convierte el string sep                                                                   arándolo por comas y añadiendo un espacio después de cada coma
      // return element.containers.split(",").join(", ");

      const ids = element.containers ? element.containers.split(",") : "";
      // const containersIdis = ids.split(",");
      const idsDone = element.containersDone
        ? element.containersDone.split(",")
        : "";
      // const containersDone = idsDone.split(",");
      return {
        id: element.id,
        po: element.po,
        rep: element.rep,
        type: element.type,
        createdAt: element.createdAt,
        numItems: element.numItems,
        askedLocation: element.askedLocation,
        toUsersData: element.toUsersData,
        containers: ids,
        containersDone: idsDone,
        status: element.status,
        numchats: element.numchats,
        deadline: element.deadline,
      };
    });
    console.log(this.data2);
  }

  public wh = "Please wait...";

  cont(e) {
    console.log(e);
    this.wh = "Please wait...";
    this.weightService.getItem(this.token, e).subscribe((r) => {
      if (r.status === "success") {
        this.wh =
          r.data.internalLocation !== null
            ? r.data.internalLocation.location
              ? r.data.internalLocation.location.name +
                " - " +
                r.data.internalLocation.locationName +
                ": " +
                r.data.internalLocation.locationRow +
                "-" +
                r.data.internalLocation.locationBay +
                "-" +
                r.data.internalLocation.locationLevel +
                "-" +
                r.data.internalLocation.locationSection
              : null
            : null;
      }
      console.log(this.wh);
    });
  }

  openlink(container) {
    window.open("/container-inventory/" + container);
  }

  unclick(i, row) {
    this.selectrow = i;
    // if(this.id === 'inventoryTable')
    //   this.saveEmit('Attribute', row[0].value);
  }

  dosclicks(row) {
    console.log(row);
  }

  saveEmit(accion, id, item = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      item: item,
    };
    this.out.emit(send);
  }

  sort(by) {
    if (by === this.orderby) {
      if (this.order === "DESC") {
        this.order = "ASC";
      } else {
        this.order = "DESC";
      }
    } else {
      this.orderby = by;
      this.order = "DESC";
    }

    let order = {
      sort: this.order,
      sortby: this.orderby,
    };

    this.sortby.emit(order);
  }

  sorting(by) {
    return this.orderby != by
      ? "fa-sort"
      : this.order == "DESC"
      ? "fa-sort-desc"
      : "fa-sort-asc";
  }
}
